import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Spinner } from 'reactstrap';

import apiClient from '@/clients/ApiClient';
import OidcClient from 'clients/OidcClient';
import './Login.css';

function SsoPage() {
  const { id } = useParams();
  const navigator = useNavigate();

  async function validateSsoIdp(ssoId: string) {
    try {
      // Remove previous SSO info if exists
      localStorage.removeItem('sso');

      if (ssoId === '00000000-0000-0000-0000-000000000000') {
        localStorage.removeItem('sso.v2');
        return navigator('/login');
      }

      const ssoInfo = await apiClient.getSsoDetails(ssoId);

      localStorage.setItem('sso.v2', btoa(JSON.stringify(ssoInfo)));

      const oidcClient = new OidcClient(ssoInfo.openIdConfig, ssoInfo.clientId);
      await oidcClient.authorizeRedirect(ssoInfo.scope ?? '', `${location.origin}/login`);
    } catch (error) {
      console.error('Invalid SSO link', error);
      return navigator('/login?error=link_error');
    }
  }

  useEffect(() => {
    void validateSsoIdp(id!);
  }, []);

  return (
    <div className="login-container center">
      <div className="col-md-6 offset-md-6">
        <Spinner />
      </div>
    </div>
  );
}

export default SsoPage;
